(function (appComponents) {


	var searchItemsCollection = function (parent) {
		var collection = {
			get isAtLeastOneElementChecked() {
				return $("[pc-container='search-results--item-checkbox']").is(':checked');
			}
		};
		collection._pord_count = 0;
		collection._templates = parent.templates;
		collection._cart = parent._cart;
		collection._panda = parent._panda;
		collection._product = parent._product;
		collection._modals = parent._modals;
		collection._messages = parent._messages;
		collection._config = parent._config;

		collection.elements = {
			getItem: function (code, type) {
				return $("[pc-container='search-results--item'][pc-value='" + code + "'][pc-product-type='" + type + "']");
			},
			get itemSpaField() {
				return $("[pc-container='search-results--item-spa-field']");
			},
			get itemSpaSelector() {
				return $("[pc-container='search-results--item-spa-selector']");
			},
			get itemQtyField() {
				return $("[pc-container='search-results--item-qty-field']");
			},
			get unitNetPriceField() {
				return $("[pc-container='search-results--item-unitnetprice-field']");
			},
			get productPanda() {
				return $("[pc-container='search-results--item-product-panda']");
			},
			get productInventoryPanda() {
				return $("[pc-container='search-results--item-product-panda-inventory']");
			},
			get kitPanda() {
				return $("[pc-container='search-results--item-kit-panda']");
			},
			get itemTableCellListPrice() {
				return $("[pc-container='search-results--table-cell-list-price']");
			},
			get itemTableCellPanda() {
				return $("[pc-container='search-results--table-cell-panda']");
			},
			get productPandaDescription() {
				return $("[pc-container='results-panda-description']");
			}

		};
		var searchProductItemPrototype = {
			get isChecked() {
				var isChecked = this._parentElement.find("[pc-container='search-results--item-checkbox']").first().is(':checked');
				return isChecked;
			},
			getSpa: function () {
				var spaField = this.elements.spaField;
				return this._parentElement.find(spaField).val();
			},
			getQty: function () {
				var qtyField = this.elements.qtyField;
				return this._parentElement.find(qtyField).val();
			},
			getPandaData: function () {
				var self = this;
				var spaValue;
				var parentElement = this._parentElement;
				var productType = parentElement.attr("pc-product-type");

				var qty = parentElement.find(collection.elements.itemQtyField).val();
				var unitNetPrice = parentElement.find(collection.elements.unitNetPriceField).val();

				if(null == qty || undefined == qty){
					qty = 1;
				}

				if (productType == "kit") {
					parentElement = this._parentProduct._parentElement;
				}

				var selectorValue = parentElement.find(collection.elements.itemSpaSelector).val();
				if (selectorValue == "not-listed") {
					spaValue = parentElement.find(collection.elements.itemSpaField).val();
				} else if (selectorValue != "listed") {
					spaValue = selectorValue;
				} else {
					spaValue = "";
				}

				var objectToReturn = {
					productCode: self.code,
					spa: (spaValue) ? spaValue : "",
					qty: qty,
					unitNetPrice:unitNetPrice
				};

				return objectToReturn;
			},
			getCartData: function () {
				return this.getPandaData();
			},
			updateViewAfterPandaCheck: function () {
				var html = null;
				var html1 = null;
				if (this._type == "product") {
					this.isEndUser = collection._config.user.isEndUser;
					html = collection._templates.productPanda(this);
					if(this._panda.longDescription != null && this._panda.longDescription != "")
					{
						html1="Notes: <span class='text-bold font-14 black-font-color'>"+this._panda.longDescription+"</span>";
						this._parentElement.find(collection.elements.productPandaDescription).html(html1);
					}
					this._parentElement.find(collection.elements.productPanda).html(html);
				} else if (this._type == "kit") {

					html = collection._templates.kitPanda(this);
					this._parentElement.find(collection.elements.itemTableCellPanda).remove();
					this._parentElement.find(collection.elements.itemTableCellListPrice).after(html);

				}
			},
			updateViewAfterPandaCheckNew: function (totalLength) {
				var html = null;
				var html1 = null;
				collection._pord_count = collection._pord_count + 1; 
				
				if (this._type == "product") {
					this.isEndUser = collection._config.user.isEndUser;
					html = collection._templates.productPanda(this);
					htmlInv = collection._templates.productPandaInventory(this);
					htmlRepl = collection._templates.productPandaReplenishment(this);
					if(this._panda.longDescription != null && this._panda.longDescription != "")
					{
						html1="Notes: <span class='text-bold font-14 black-font-color'>"+this._panda.longDescription+"</span>";
						this._parentElement.find(collection.elements.productPandaDescription).html(html1);
					}
					this._parentElement.find(collection.elements.productPanda).html(html);
					$("[pc-container='search-results--item-product-panda-inventory"+this.code+"']").html(htmlInv);
					$("[pc-container='search-results--item-product-panda-replenishment"+this.code+"']").html(htmlRepl);
					if(collection._pord_count === totalLength){
						collection._pord_count = 0;
						collection._modals.loading.hide();
					}
					
				} else if (this._type == "kit") {

					html = collection._templates.kitPanda(this);
					this._parentElement.find(collection.elements.itemTableCellPanda).remove();
					this._parentElement.find(collection.elements.itemTableCellListPrice).after(html);
					if(collection._pord_count === totalLength){
						collection._pord_count = 0;
						collection._modals.loading.hide();
					}
				}
				
			},
			checkPanda: function () {
				var self = this;

				var data = this.getPandaData();
				var kitsData = [];

				if (this._kits) {
					this._kits.forEach(function (kit) {
						//kitsData.push(kit.getPandaData());
					});
				}

				var dataToSend = [].concat([data], kitsData);
				collection._panda.checkPriceAndAvailability(dataToSend).then(function (pandaData) {
					self._panda = pandaData.products[self.code];

					if (self._kits) {
						self._kits.forEach(function (kit) {
							kit._panda = pandaData.products[kit.code];
							kit.updateViewAfterPandaCheck();
						});
					}

					self.updateViewAfterPandaCheck();
				});
			},
			checkPandaNew: function (totalLength) {
				var self = this;
               
				var data = this.getPandaData();
				var kitsData = [];

				if (this._kits) {
					this._kits.forEach(function (kit) {
						//kitsData.push(kit.getPandaData());
					});
				}

				var dataToSend = [].concat([data], kitsData);
				collection._panda.checkPriceAndAvailability(dataToSend).then(function (pandaData) {
					self._panda = pandaData.products[self.code];

					if (self._kits) {
						
						self._kits.forEach(function (kit) {
							kit._panda = pandaData.products[kit.code];
							kit.updateViewAfterPandaCheck();
						});
					}
					var myJSON = JSON.stringify(self._panda);
					
					
				  self.updateViewAfterPandaCheckNew(totalLength);
				  
				  if(collection.collection != undefined && pandaData != undefined) {
					  
					  	// Updating Unit Net Price for the Main Product in the Collection
						var newPandaData = pandaData.products[self.code];
						collection.collection.forEach(function (el) {
							if (newPandaData !== undefined && el.code == self.code) {
								el.unitPrice = newPandaData.netPrice;
							}
							
							// Updating Unit Net Price for the Kits Products in the Collection
							if (self._kits) {
								self._kits.forEach(function (kit) {
									var kitPandaData = pandaData.products[kit.code];
									if(kitPandaData != undefined && el.code == kit.code) {
										el.unitPrice = kitPandaData.netPrice;
									}
								});
							}
					  });
				  }
				  
				}).catch(function(error){
					//error handling
					collection._modals.loading.hide();
				});
			},
			addToCart: function () {
				var data = this.getCartData();
				collection._cart.addItems([data]);
			},
			sendReplFeedback: function () {
				collection._panda.initFeedback(this);
			},
			showPandaDetails: function () {
				collection._panda.showDetails(this);
			},
			showProductDetails: function () {
				collection._product.showDetails(this);
			},
			downloadDataPack: function (type) {
				collection._product.downloadDataPack(this.stockId, type);
			}
		};

		collection.addToCartBatch = function () {
			var dataArray = [];

			this.collection.forEach(function (item) {
				if (item.isChecked) {
					var data = item.getCartData();
					dataArray.push(data);
				}
			});

			collection._cart.addItems(dataArray);

		};

		collection.getPriceAvailability = function (items, totalLength) {
			var selfs = items.slice(0) ;
		   
			var productData = [];

			items.forEach(function (item) {
				productData.push(item.getPandaData());
			});

			var dataToSend = productData.slice(0);
			collection._panda.checkPriceAndAvailability(dataToSend).then(function (pandaData) 
			{
				selfs.forEach(function (self) 
				{
					self._panda = pandaData.products[self.code];
					self.updateViewAfterPandaCheckNew(totalLength);
					if(collection.collection != undefined && pandaData != undefined) 
					{
					   // Updating Unit Net Price for the Main Product in the Collection
						var newPandaData = pandaData.products[self.code];
						collection.collection.forEach(function (el) 
						{
							if (newPandaData !== undefined && el.code == self.code) 
							{
								el.unitPrice = newPandaData.netPrice;
							}
						});
					}
				});
			}).catch(function(error){
				console.log(error);
				collection._modals.loading.hide();
			});
		};

		collection.checkPandaBatch = function () {
			var pandaArray = [];
			var arrayWithoutPcParts = [];

			this.collection.forEach(function (item) {
				if (!item.pcPart && item.isChecked) {
					var data = item.getPandaData();
					pandaArray.push(data);
					arrayWithoutPcParts.push(item);
				}
			});

			if (!arrayWithoutPcParts.length) {
				collection._modals.warning.show(collection._messages.noProductsForPanda);
				return;
			}

			collection._panda.checkPriceAndAvailability(pandaArray).then(function (pandaData) {
				arrayWithoutPcParts.forEach(function (el, idx, arr) {
					el._panda = pandaData.products[el.code];
					el.updateViewAfterPandaCheck();
				});
			});
		};

		collection.findItemByCode = function (code, combinedKitCode) {
			var productToReturn = null;

			if (combinedKitCode) {
				this.collection.forEach(function (el) {
					if (productToReturn != null) return;

					if (el._combinedKitCode == combinedKitCode) {
						productToReturn = el;
					}
				});
			} else {
				this.collection.forEach(function (el) {
					if (productToReturn != null) return;

					if (el.code == code) {
						productToReturn = el;
					}
				});
			}
			return productToReturn;
		};

		collection.getItemsForCodes = function (combinedKitCode,count) {
			var productsToReturn = [];			
			if (combinedKitCode) {
				this.collection.forEach(function (el) {
					if (productsToReturn.length == count) return;

					if ($.inArray(el.code, combinedKitCode) != -1) {
						productsToReturn.push(el);
					}
				});
				return productsToReturn;
			} 
		};

		collection.setCollection = function (products, kits) {

			if (!products) return;
			
			var kitTargetsArray = [];

			products.forEach(function (product) {
				product._parentElement = collection.elements.getItem(product.code, "product");
				product._type = "product";
				product.__proto__ = searchProductItemPrototype;

				if ( kits == null || kits[product.code] == null) return;

				product._kits = [];

				kits[product.code].forEach(function (kit) {
					kit.target._parentProduct = product;
					kit.target._parentElement = product._parentElement.find(collection.elements.getItem(kit.target.code, "kit"));
					kit.target._type = "kit";
					kit.target.__proto__ = searchProductItemPrototype;

					kit.target._combinedKitCode = kit.target._parentProduct.code + kit.target.code;
					kit.target._parentElement.attr("pc-combined-kit-code", kit.target._combinedKitCode);

					kitTargetsArray.push(kit.target);

					product._kits.push(kit.target);
				});

			});

			var concatedProducts = products.concat(kitTargetsArray);

			this.collection = concatedProducts;

		};

		return collection;
	};


	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.searchResults == null) appComponents.pageComponents.searchResults = {};
	appComponents.pageComponents.searchResults.searchItemsCollection = searchItemsCollection;

	window.appComponents = appComponents;

})(window.appComponents || {});